import authActions from "../actions/authActions";
import userActions from "../actions/userAction";
import helpersEncrypt from "../../helpers/encrypt";

const mainState = {
  mobile: null,

  authStatus: null,

  isUserLoggedIn: false,

  isInit: false,
  userID: null,
  firstNameUser: null,
  lastNameUser: null,
  categoryUser: null,
  role: null,

  permissionsUser: null,

  charge: 0,

  hasMessage: false,
  typeMessage: null,
  message: null,

  marketer_id: null,
  is_get_gift: null,
};
const main = (state = mainState, action) => {
  let newState = state;

  switch (action.type) {
    case authActions.MOBILE_USER_WRONG:
      newState = {
        ...state,
        hasMessage: true,
        typeMessage: action.payload.typeMessage,
        message: action.payload.message,
      };
      break;

    case authActions.USER_ENTER_MOBILE_FOR_LOGIN_SUCCESS:
      newState = {
        ...state,
        mobile: action.payload,
        authStatus: authActions.SEND_CODE_SMS_TO_USER,
      };

      break;

    case authActions.CHECK_SMS_CODE_MOBILE_FOR_LOGIN_SUCCESS:
      break;

    case authActions.CHECK_SMS_CODE_MOBILE_FOR_LOGIN_FAILED:
      newState = {
        ...state,
        hasMessage: true,
        typeMessage: action.payload.typeMessage,
        message: action.payload.message,
      };
      break;

    case authActions.CHECK_USER_LOGIN_SUCCESS:
      let userInfo;
      if (action.payload.user_info != null) {
        userInfo = {
          firstNameUser: action.payload.user_info.firstName,
          lastNameUser: action.payload.user_info.lastName,
          email: action.payload.user_info.email,
          mobile: action.payload.user_info.mobile,
          role: action.payload.user_info.role_persian,
          marketer_id: action.payload.user_info.marketer_id,
          is_get_gift: action.payload.user_info.is_get_gift,
        };
        if (action.payload.user_info.category != null) {
          userInfo.categoryUser = action.payload.user_info.category;
        }
        userInfo.charge = action.payload.charge;
      }

      newState = {
        ...state,
        isUserLoggedIn: true,
        isInit: true,
        userID: action.payload.user_id,
        permissionsUser: helpersEncrypt.decryptArrayUserPermissions(
          action.payload.permissions
        ),
        ...userInfo,
      };
      break;

    case authActions.CHECK_USER_LOGIN_FAILED:
      newState = {
        ...state,
        isInit: true,
      };
      break;

    case authActions.USER_DO_LOGOUT:
      localStorage.removeItem("token");
      newState = {
        ...state,
        isUserLoggedIn: false,
      };
      break;

    case authActions.SEND_SMS_LOGIN_CODE_AGAIN:
      newState = {
        ...state,
        authStatus: null,
      };
      break;

    case userActions.ENTER_USER_FIRSTNAME_LASTNAME:
      newState = {
        ...state,
        firstNameUser: action.payload.firstName,
        lastNameUser: action.payload.lastName,
        categoryUser: action.payload.categoryUser,
      };
      break;
  }
  return newState;
};
export default main;
